import Breadcrumb from "../Component/Breadcrumb";
const MandatoryDisclosure = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Mandatory Disclosure"
        breadmid="CBSE Disclosure"
        breadend="Mandatory Disclosure"
      />
      <div className="innerpage">
        <div className="container">
          <div class="row">
            <div class="col-12">
              <h2 className="maintitle">
                Mandatory Public Disclosure{" "}
                <a
                  class="mandlink"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Mandatory-Public-Disclosure.pdf#toolbar=0&amp;navpanes=0"
                  target="_blank"
                >
                  {" "}
                  View{" "}
                </a>
              </h2>

              <strong>A. GENERAL INFORMATION </strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  className="table"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th width="15%">
                        <strong>SL. NO. </strong>
                      </th>
                      <th width="60%">
                        <strong>INFORMATION</strong>
                      </th>
                      <th width="25%">
                        <strong>DETAILS</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>1.</strong>
                      </td>
                      <td>NAME OF THE SCHOOL</td>
                      <td>CANOSSA SCHOOL</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>2.</strong>
                      </td>
                      <td>AFFILIATION NO (IF APPLICABLE)</td>
                      <td>2131225</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>3.</strong>
                      </td>
                      <td>SCHOOL CODE (IF APPLICABLE)</td>
                      <td>70965</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>4.</strong>
                      </td>
                      <td>COMPLETE ADDRESS WITH PIN CODE</td>
                      <td>
                        KUKRAIL PICNIC SPOT ROAD FARIDINAGAR.LUCKNOW - 226016,
                        LUCKNOW , UTTAR PRADESH- 226015
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>5.</strong>
                      </td>
                      <td>PRINCIPAL NAME &amp; QUALIFICATION</td>
                      {/* <td>Sr. NEEMA M.A. &amp; M SC, B ED </td> */}
                      <td>Sr. NEEMA M.A.</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>6.</strong>
                      </td>
                      <td>SCHOOL EMAIL ID</td>
                      <td>
                        <a href="mailto:canossaschool@rocketmail.com">
                          canossaschool@rocketmail.com
                        </a>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>7.</strong>
                      </td>
                      <td>CONTACT DETAILS</td>
                      <td>
                        <a href="tel:9528761669"> 9528761669</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <strong>B. DOCUMENTS AND INFORMATION </strong>
              <br />
              <br />
              <div class="innertable  table-responsive">
                <table
                  border="1"
                  className="table"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th width="15%">
                        <strong>SL. NO. </strong>
                      </th>
                      <th width="60%">
                        <strong>DOCUMENTS</strong>
                        <strong>INFORMATION</strong>
                      </th>
                      <th width="25%">
                        <strong>UPLOAD DOCUMENTS</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>1.</strong>
                      </td>
                      <td>
                        COPIES OF AFFILIATION /UPGRADATION LETTER AND RECENT
                        EXTENSION OF AFFILIATION , IF ANY
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/affiliation.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>2.</strong>
                      </td>
                      <td>
                        COPIES OF SOCIETY /TRUST/COMPANY REGISTRATION/RENEWAL
                        CERTIFICATE AS APPLICABLE
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/society.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>3.</strong>
                      </td>
                      <td>
                        COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED. IF
                        APPLICABLE BY THE STATE GOVT/UT
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/noc.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>4.</strong>
                      </td>
                      <td>
                        COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT 2009 AND
                        ITS RENEWAL IF APPLICABLE
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Renewal-Affi.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>5.</strong>
                      </td>
                      <td>COPIES OF CBSE RECOGNITION CERTIFICATE</td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/CBSERecognition.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>6.</strong>
                      </td>
                      <td>
                        COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE
                        NATIONAL BUILDING CODE
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/buildingcertificate.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>7.</strong>
                      </td>
                      <td>
                        COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE
                        COMPETENT AUTHORITY
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/firecertificate.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>8.</strong>
                      </td>
                      <td>
                        COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR
                        AFFILIATION /UPGRADATION /EXTENSION OF AFFILIATION SELF
                        CERTIFICATION BY SCHOOL
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/DEO.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>9.</strong>
                      </td>
                      <td>
                        COPIES OF VALID WATER HEALTH AND SANITATION CERTIIFCATES
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/water-health-certificate.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <strong>
                NOTE: THE SCHOOL NEEDS TO SELF ATTESTED COPIES OF ABOVE
                DOCUMENTS B Y CHAIRMAN/MANAGER/SECETARY AND PRINCIPAL IN CASE IT
                IS NOTICED AT LATER STAGE THAT UPLOADED DOCUMENTS ARE NOT
                GENUINE THEN SCHOOL SHALL BE LIABLE FOR ACTION AS PER NORMS.
              </strong>
              <br />
              <br />
              <strong>C. RESULT AND ACADEMICS</strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  className="table"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th width="15%">
                        <strong>S.No</strong>
                      </th>
                      <th width="60%">
                        <strong>DOCUMENTS/INFORMATION</strong>
                      </th>
                      <th width="25%">
                        <strong>UPLOAD DOCUMENTS</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>1.</strong>
                      </td>
                      <td>FEE STRUCTURE OF THE SCHOOL</td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Fee-Structure-26-27.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>2.</strong>
                      </td>
                      <td>ANNUAL ACADEMIC CALENDAR</td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Academic-Calendar.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>LIST OF SCHOOL MANAGEMENT COMMITTEE</td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/SMC.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>
                        LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/PTA.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>5.</td>
                      <td>
                        LAST THREE YEAR RESULT OF THE BOARD EXAMINATION AS PER
                        APPLICABILITY
                      </td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Last-Three-Year-Results.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <td>6.</td>
                      <td> SCHOOL TEACHER'S LIST</td>
                      <td>
                        <a
                          href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/pdf/Teachers-List.pdf#toolbar=0&amp;navpanes=0"
                          target="_blank"
                        >
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <strong>D. STAFF TEACHING</strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  border="1"
                  className="table"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th width="15%">S.NO</th>
                      <th width="60%">INFORMATION</th>
                      <th width="25%">DETAILS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>PRINCIPAL</td>
                      <td>Sr. NEEMA M.A.</td>
                    </tr>
                    <tr>
                      <td rowspan="4">2.</td>
                      <td>TOTAL NO OF TEACHERS</td>
                      <td>58</td>
                    </tr>
                    <tr>
                      <td>PGT</td>
                      <td>13</td>
                    </tr>
                    <tr>
                      <td>TGT</td>
                      <td>18</td>
                    </tr>
                    <tr>
                      <td>PRT</td>
                      <td>27</td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>TEACHERS SECTION RATIO</td>
                      <td>1:40</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>DETAILS OF SPECIAL EDUCATOR</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>DETAILS OF COUNSELLOR AND WELNESS TEACHER</td>
                      <td>1</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <strong>RESULT CLASS: X </strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  border="1"
                  className="table"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>
                        <strong>S.NO.</strong>
                      </th>
                      <th>
                        <strong>YEAR</strong>
                      </th>
                      <th>
                        <strong>NO. OF REGISTERED STUDENTS </strong>
                      </th>
                      <th>
                        <strong>NO. OF STUDENTS PASSED </strong>
                      </th>
                      <th>
                        <strong>PASS CERTIFICATE </strong>
                      </th>
                      <th>
                        <strong>REMARKS</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>2023 </td>
                      <td>138 </td>
                      <td>137 </td>
                      <td>99.3 </td>
                      <td>One compartment</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <strong> RESULT CLASS: XII </strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  className="table"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>
                        <strong>S.NO.</strong>
                      </th>
                      <th>
                        <strong>YEAR</strong>
                      </th>
                      <th>
                        <strong>NO. OF REGISTERED STUDENTS </strong>
                      </th>
                      <th>
                        <strong>NO. OF STUDENTS PASSED </strong>
                      </th>
                      <th>
                        <strong>PASS CERTIFICATE </strong>
                      </th>
                      <th>
                        <strong>REMARKS</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>2023</td>
                      <td>113</td>
                      <td>111 </td>
                      <td>98.2</td>
                      <td>Two compartment</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
              <strong>E. SCHOOL INFRASTRUCTURE</strong>
              <br />
              <br />
              <div class="innertable table-responsive">
                <table
                  className="table"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th width="15%">S.NO</th>
                      <th width="60%">INFORMATION</th>
                      <th width="25%">DETAILS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQ. METER) </td>
                      <td>15880</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>NO. AND SIZE OF THE CLASS ROOMS (IN SQ FT METER)</td>
                      <td>48 &amp; 665 </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>
                        NO AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS ( IN
                        SQ MTR)
                      </td>
                      <td>8 &amp; 112</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>INTERNET FACILITY (Y/N)</td>
                      <td>YES</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>NO. OF GIRLS TOILETS</td>
                      <td>25 </td>
                    </tr>
                    <tr>
                      <td>6.</td>
                      <td>NO. OF BOYS TOILETS</td>
                      <td>10 </td>
                    </tr>
                    <tr>
                      <td>7.</td>
                      <td>
                        LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL
                        COVERING THE INFRASTUCTURE OF THE SCHOOL
                      </td>
                      <td>
                        <a href="https://youtu.be/c3iFF7gVoBg" target="_blank">
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MandatoryDisclosure;
